import {
  Heading4,
  Button,
  ButtonColorVariant,
  Box,
  FlexDirection,
  Body1,
  Text,
  FontWeight,
  Color,
  JustifyContent,
  TextAlign,
  withCitrusTheme,
  BorderStyle,
  Space,
  Join,
} from '@gousto-internal/citrus-react'
import React from 'react'
import { UseRafCampaignDetails, useRafCampaignDetails } from '../hooks/useRafCampaignDetails'

const ReferAFriend = () => {
  const { data, error, isLoading } = useRafCampaignDetails()

  const renderOffer = () => {
    if (isLoading) {
      return <Text>Loading...</Text>
    }

    if (error) {
      return <Text>Something went wrong</Text>
    }

    return (
      <>
        <OfferBox data={data} />
        <Join with={<Space direction={'vertical'} size={4} />}>
          <Button
            aria-labelledby="share-your-link-button"
            colorVariant={ButtonColorVariant.Primary}
            width={'100%'}
          >
            Copy Invite Link
          </Button>
          <Body1>Share your invite code:</Body1>
          <Button colorVariant={ButtonColorVariant.Secondary} width={'100%'}>
            Messenger
          </Button>
          <Button colorVariant={ButtonColorVariant.Secondary} width={'100%'}>
            Facebook
          </Button>
        </Join>
      </>
    )
  }

  return (
    <Box>
      <Heading4 size={5}>Invite your friends to try Gousto</Heading4>
      {renderOffer()}
    </Box>
  )
}

const OfferHeading = withCitrusTheme(Text, (theme) => ({
  fontWeight: FontWeight.Bold,
  color: theme.color(Color.ColdGrey_800),
  textAlign: TextAlign.Center,
}))

const OfferDescription = withCitrusTheme(Text, (theme) => ({
  color: theme.color(Color.ColdGrey_800),
  textAlign: TextAlign.Center,
}))

const OfferBox = ({ data }: { data: UseRafCampaignDetails['data'] }) => {
  const {
    creditFormatted,
    firstBoxDiscountFormatted,
    firstMonthDiscountFormatted,
    discountDurationFormatted,
  } = data

  return (
    <Box
      display={'flex'}
      flexDirection={FlexDirection.Row}
      justifyContent={JustifyContent.Center}
      gap={3}
      paddingV={6}
    >
      <Box data-testid="refer-a-friend-credit" width={'100%'} paddingH={4}>
        <Body1>
          <OfferHeading size={4}>You get </OfferHeading>
          <OfferHeading size={13}>{creditFormatted} </OfferHeading>
          <OfferDescription size={2}>when their first order is delivered</OfferDescription>
        </Body1>
      </Box>
      <Box borderWidth={0.5} borderStyle={BorderStyle.Dashed} />
      <Box data-testid="refer-a-friend-discount" width={'100%'} paddingH={4}>
        <Body1>
          <OfferHeading size={4}>Your friend gets </OfferHeading>
          <OfferHeading size={13}>{firstBoxDiscountFormatted} </OfferHeading>
          <OfferDescription size={2}>
            off their first order + {firstMonthDiscountFormatted} off their first{' '}
            {discountDurationFormatted}
          </OfferDescription>
        </Body1>
      </Box>
    </Box>
  )
}

export default ReferAFriend
